import { combineReducers } from 'redux'
import _ from 'lodash'

import * as dashboardSummary from './dashboardSummary'

const slices = {
  dashboardSummary
}

const dashboardTypes = _.mapValues(slices, (s) => s.slice.types)
const dashboardActions = Object.assign({}, ..._(slices).values().map('slice.actions').value())
const dashboardSagas = _(slices).values().map('slice.sagas').flatten().value()
const dashboardSelectors = Object.assign({}, ..._(slices).values().map('slice.selectors').value())
const reducers = Object.assign({}, ..._(slices).values().map('default').value())

export { dashboardTypes, dashboardActions, dashboardSagas, dashboardSelectors }

export default combineReducers(reducers)
